import { NumberInput, type NumberInputProps } from '@chakra-ui/react'
import { SizeType, InputVariant } from '@/types'
import React from 'react'


interface Props extends NumberInputProps {
  variant?: InputVariant,
  size?: SizeType,
}

const Component = React.forwardRef((props: Props, ref: React.Ref<any>) => {
  return (
    <NumberInput ref={ref} {...props} />
  )
})

export {
  Component as NumberInput,
  type Props as NumberInputProps,
}